import Request from './request'
import snackbar from '@/plugins/snackbar';
import i18n from '@/i18n';
import store from "../store";

async function fetch(id) {
  return Request('get', "api/purchase-user-tasks/index?stock_id=" + id);
}

async function add(data) {// 新增采购任务
  return Request('post', "api/purchase-user-tasks/add", data);
}

async function edit(data) {//编辑采购任务
  return Request('post', "api/purchase-user-tasks/edit", data);
}

async function saveTaskCategories(data) {//保存任务详情
  return Request('post', "api/purchase-user-tasks/save-task-categories", data);
}

async function getAccountUsers(data) {//获取已绑定的采购员
  return Request('get', "api/purchase-user-tasks/get-account-users", data);
}

async function getUserCategories(data) {//获取默认绑定关系
  return Request('post', "api/purchase-user-tasks/get-user-categories", data);
}

async function Export(data) {
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/purchase-user-tasks/material-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function Import(id,file) {// 导入
  var data = new FormData();
  data.append("excel", file);
  data.append("stock_id", id);
  return Request('post', "api/purchase-user-tasks/material-import",data)
}


export default {
  fetch,
  add,
  edit,
  saveTaskCategories,
  getAccountUsers,
  getUserCategories,
  Import,
  Export
};